// extracted by mini-css-extract-plugin
module.exports = {"root":"AccountMenu_root__1VkN2","avatar":"AccountMenu_avatar__1Ss6a"};